import { css } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';

import { useSDK } from '../../../app';
import { styled } from '../../../styled';
import type { Theme } from '../../../theme/interface/detailed';
import { isMobile } from '../../../utils/isMobile';
import { useSanitize } from '../../../utils/useSanitize';

type Interface = { className: string };

const DEFAULT_HEADER_MESSAGE = 'Оставьте контактные данные, и мы свяжемся с Вами в ближайшее время.';

const firstTextStyle = { fontWeight: 'bold' } as const;

const Component = observer(({ className }: Interface): ReactElement => {
	const { welcomeDataStore } = useSDK();
	const headerHtml = useSanitize(welcomeDataStore.data?.showcase.offlineFormWelcomeText || '');
	return (
		<div className={className}>
			{headerHtml ? (
				<div dangerouslySetInnerHTML={headerHtml}></div>
			) : (
				<>
					<span
						css={css`
							span& {
								${firstTextStyle}
							}
						`}
					>
						{DEFAULT_HEADER_MESSAGE}
					</span>
				</>
			)}
		</div>
	);
});

const OfflineChatHeader = styled(Component)(
	({
		theme: {
			offlineChat: {
				header: { offlinePrechatHeader },
			},
		},
	}: {
		theme: Theme;
	}) => offlinePrechatHeader,
	css`
		display: flex;
		flex-direction: column;
		grid-gap: 4px;

		& > div {
			${isMobile ? 'padding: 0 20px' : ''}
		}
	`
);

export { OfflineChatHeader };
